/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {Observable} from 'rxjs';
import {SupplyingPackingPlantBaseModel} from './contracts/supplying-packing-plant-base.model';
import {TransportModeBaseModel} from './contracts/transport-mode-base.model';
import {TransportServiceBaseModel} from './contracts/transport-service-base.model';
import { HttpClient } from '@angular/common/http';
import {Cacheable} from '../../decorators/cacheable.decorator';

@Injectable({
    providedIn: 'root'
})
export class ReferenceDataApi {
    private referenceDataBaseUrl = `${environment.specialOrdersBaseUrl}/api/route`;
    private supplyingPackingPlantUrl = `${this.referenceDataBaseUrl}/supplyingPackingPlant/base/active`;
    private transportModeUrl = `${this.referenceDataBaseUrl}/transportMode/base/active`;
    private transportServiceUrl = `${this.referenceDataBaseUrl}/transportService/base/active`;

    constructor(protected http: HttpClient) {
    }

    /**
     * This method retrieves the active Supplying Packing Plants by Ship to Party
     * @param shipToPartyCode The Ship to Party code
     */
    @Cacheable()
    getActiveSupplyingPackingPlants(shipToPartyCode: string): Observable<SupplyingPackingPlantBaseModel[]> {
        return this.http.get<SupplyingPackingPlantBaseModel[]>(`${this.supplyingPackingPlantUrl}?shipToPartyCode=${shipToPartyCode}`);
    }

    /**
     * This method retrieves the active Transport Modes by Ship to Party and Supplying Packing Plant code
     * @param shipToPartyCode The Ship to Party code
     * @param plantCode The Supplying Packing Plant code
     */
    @Cacheable()
    getActiveTransportModes(shipToPartyCode: string, plantCode: string): Observable<TransportModeBaseModel[]> {
        return this.http.get<TransportModeBaseModel[]>(`${this.transportModeUrl}?` + [
            `shipToPartyCode=${shipToPartyCode}`,
            `plantCode=${plantCode}`
        ].join('&'));
    }

    /**
     * This method retrieves the active Tranport Services by Ship to Party, Supplying Packing Plant and Transport Service code
     * @param shipToPartyCode The Ship to Party code
     * @param plantCode The Supplying Packing Plant code
     * @param transportModeCode The Transport Mode code
     */
    @Cacheable()
    getActiveTransportServices(shipToPartyCode: string,
                               plantCode: string,
                               transportModeCode: string): Observable<TransportServiceBaseModel[]> {
        return this.http.get<TransportServiceBaseModel[]>(`${this.transportServiceUrl}?` + [
            `shipToPartyCode=${shipToPartyCode}`,
            `plantCode=${plantCode}`,
            `transportModeCode=${transportModeCode}`
        ].join('&'));
    }
}
